// extracted by mini-css-extract-plugin
export default {"sortUpFilled":"SortingIcon_sortUpFilled__JlZNU","sortDown":"SortingIcon_sortDown__OacUA","sortDownFilled":"SortingIcon_sortDownFilled__V8C6x"};